document.addEventListener('DOMContentLoaded', function() {
    // Open dropdown
    document.addEventListener('click', function(e) {
        const trigger = e.target.closest('[data-promo-trigger]');
        if (!trigger) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        trigger.classList.toggle('promo-selector__trigger--active');
    });
    // Select option
    document.addEventListener('click', function(e) {
        const option = e.target.closest('.promo-selector__option');
        if (!option) return;
        const selector = option.closest('[data-promo-selector]');
        const trigger = selector.querySelector('[data-promo-trigger]');
        const text = trigger.querySelector('.promo-selector__text');
        const warning = selector.querySelector('[data-promo-warning]');
        const selectedValue = option.dataset.value;
        const selectedText = option.querySelector('.promo-selector__option-title').textContent.trim();
        const selectedPromo = {
            value: selectedValue,
            productId: option.dataset.productId,
            variantId: option.dataset.variantId,
            variantTitle: option.dataset.variantTitle,
            productTitle: option.dataset.productTitle,
            text: selectedText
        };
        text.textContent = selectedText;
        trigger.classList.add('promo-selector__trigger--selected');
        trigger.classList.remove('promo-selector__trigger--active');
        warning.classList.remove('promo-selector__warning--visible');
        console.log('dispatching event');
        const event = new CustomEvent('promoSelected', {
            detail: {
                selected: true,
                promo: selectedPromo
            }
        });
        document.dispatchEvent(event);
    });
    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
        const clickedTrigger = e.target.closest('[data-promo-trigger]');
        const clickedDropdown = e.target.closest('[data-promo-dropdown]');
        if (!clickedTrigger && !clickedDropdown) {
            document.querySelectorAll('[data-promo-trigger]').forEach(trigger => {
                trigger.classList.remove('promo-selector__trigger--active');
            });
        }
    });
});

// Hover effect for top option
let isHoveringFirstOption = false;
document.addEventListener('mouseover', function(e) {
    const firstOption = e.target.closest('.promo-selector__option:first-child');
    if (!firstOption || isHoveringFirstOption) {
        return;
    }
    isHoveringFirstOption = true;
    const selector = firstOption.closest('[data-promo-selector]');
    const trigger = selector.querySelector('[data-promo-trigger]');
    if (!trigger.classList.contains('promo-selector__trigger--selected')) {
        trigger.style.borderBottomColor = '#6CC24A';
    }
});
document.addEventListener('mouseout', function(e) {
    const firstOption = e.target.closest('.promo-selector__option:first-child');
    if (!firstOption) {
        return;
    }
    const relatedTarget = e.relatedTarget;
    const stillHovering = relatedTarget && relatedTarget.closest('.promo-selector__option:first-child');
    if (stillHovering) {
        return;
    }
    isHoveringFirstOption = false;
    const selector = firstOption.closest('[data-promo-selector]');
    const trigger = selector.querySelector('[data-promo-trigger]');
    if (!trigger.classList.contains('promo-selector__trigger--selected')) {
        trigger.style.borderBottomColor = '';
    }
});